import Styled, { css } from 'styled-components';

import { media } from '../../../../lib/StyledComponents';
import { Card } from '../../../Card';
import { cssDeclaration } from '../../../_ThemeTwo_/Utils/Styles/cssDeclaration';

import { IVerTaskCard } from './common';
import { VerTaskCta } from './TaskCardCta';

export const TaskCardContain = Styled(Card)<IVerTaskCard>`
  margin-bottom: 1em;
  padding: 1.25em 3em 1.25em 2em;
  position: relative;
  color: ${({ theme: { taskCard }}) => taskCard.colorText};

  ${({ theme: { taskCard, themeTwo }}) => taskCard.card && css`
    padding: ${taskCard.card.padding && taskCard.card.padding.mobile};
    /* margin */ ${taskCard.card.margin && cssDeclaration(themeTwo, 'margin', taskCard.card.margin)};
  `}

  &:hover {
    cursor: pointer;

    ${({ theme: { taskCard }}) => taskCard.ctaText && css`
      ${VerTaskCta} {
        text-decoration: ${taskCard.ctaText.textDecoration};
        color: ${taskCard.ctaText.color};
      }
    `}
  }

  &::before {
    height: 100%;
    width: 4px;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    background: ${({ theme: { taskCard }}) => taskCard.colorBorder};
    border-radius: ${({ theme: { card } }) => card.borderRadius} 0 0 ${({ theme: { card } }) => card.borderRadius};
    transition: width 100ms ease-out;
  }

  ${props => (!props.preventCompleteColor && (props.inReview || props.isComplete)) && `
    color: ${props.theme.taskCard.colorCompleteText};

    &:hover {
      cursor: default;
    }

    p,
    small {
      color: ${props.theme.taskCard.colorCompleteText};
    }
  `}

  ${props => props.inReview && `
    &::before {
      background: ${props.theme.taskCard.colorInReviewBorder};
    }
  `}

  ${props => props.isComplete && `
    &::before {
      height: 0;
      width: 0;
    }
  `}

  ${media.small`
    padding: 1.75em 3.5em 1.75em 2em;
  `}

  ${({ theme: { taskCard }}) => taskCard.card &&
    media.small`
      padding: ${taskCard.card.padding && taskCard.card.padding.small};
    `
  }

  ${media.medium`
    &:hover {
      transition: width 100ms ease-out;
    }

    &:hover::before {
      width: 6px;
    }
  `}
`;
